export default function initUploadForm() {
    const $uploadFormContainer = document.querySelectorAll<HTMLElement>('.js-upload-form-wrapper');
    $uploadFormContainer.forEach($container => {
        new UploadForm($container);
    });
}

export class UploadForm {
    $container: HTMLElement;
    $form: HTMLFormElement;
    $uploadFileWrappers: NodeListOf<HTMLElement>;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$form = this.$container.querySelector('.upload-form') as HTMLFormElement;
        this.$uploadFileWrappers = this.$form.querySelectorAll('.upload-file-wrapper');
        this.init();
    }

    init(): void {
        this.$uploadFileWrappers.forEach((uploadFileWrapper) => {
            this.uploadHandler(uploadFileWrapper);
        })
    }

    /**
 * Gère l'affichage du preview du fichier et le drag n drop
 *
 * @return {void}
 */
    uploadHandler(uploadFileWrapper: HTMLElement): void {
        const dropArea = uploadFileWrapper.querySelector('.drag-area') as HTMLElement;
        const filePreview = uploadFileWrapper.querySelector('.drag-area-file-preview') as HTMLElement;
        const inputFile = uploadFileWrapper.querySelector('input[type="file"]') as HTMLInputElement;
        const maxSize = 25 * 1024 * 1204; // 25 MO
        
        inputFile.addEventListener('dragenter', () => {
            uploadFileWrapper?.classList.add('upload-file-wrapper--dragged');
        })

        inputFile.addEventListener('change', () => {
            if (inputFile.files) {
                for (const file of inputFile.files) {
                    const fileSize = file.size;
            
                    if (maxSize && fileSize > maxSize) {
                        alert('La taille du fichier dépasse la limite maximale autorisée (25 Mo). Veuillez sélectionner un fichier plus petit.');
                        return false;
                    } else {
                        showFile(file);
                    }
                }

                // Affichage de la preview du fichier
                filePreview.classList.remove('drag-area-file-preview--hidden');
                dropArea.classList.add('drag-area--hidden');
                uploadFileWrapper?.classList.remove('upload-file-wrapper--dragged');
                uploadFileWrapper?.classList.add('upload-file-wrapper--active');
            }
        });

        const showFile = (file: File) => {
            filePreview.classList.add('drag-area-file-preview--active');
            // On clone le premier file-info qui est toujours caché
            const firstFileInfoNode = uploadFileWrapper?.querySelectorAll('.file-info')[0];
            const clonedFileInfoNode  = firstFileInfoNode.cloneNode(true) as HTMLDivElement;
            
            const titleElement = clonedFileInfoNode.querySelector('.file-title');
            
            if (titleElement) {
                titleElement.textContent = file.name;
            }
            
            firstFileInfoNode.parentNode?.appendChild(clonedFileInfoNode);
            
            const fileToRemove = file;
            const removeFileButton = clonedFileInfoNode.querySelector('button');
            
            removeFileButton?.addEventListener('click', () => {
                if (inputFile.files) {
                    const updatedFiles = Array.from(inputFile.files).filter(file => file !== fileToRemove);
                    firstFileInfoNode.parentNode?.removeChild(clonedFileInfoNode);
                    
                    dropArea.classList.remove('drag-area--hidden');

                    const dataTransfer = new DataTransfer();
                    updatedFiles.forEach(file => {
                        dataTransfer.items.add(file);
                    });

                    inputFile.files = dataTransfer.files;
                }
            });
        }
    }
}
